export default {"src":"/_next/static/media/authentication_error.6c4a5801.svg","height":101,"width":147,"blurWidth":0,"blurHeight":0};